import { useMemo } from 'react';

import { isImg, isVideo } from '@shared/helpers';

import { UploadedProgressMediaItem } from '../../../Context/ProgressContext';

interface ProgressMediaItem {
    id: number;
    mime_type: string;
    original_url: string;
    video_url?: string;
    date?: string;
    description?: string;
}

export const useProgressMediaData = (
    progress: ProgressMediaItem[],
    uploadedProgressMediaList: UploadedProgressMediaItem[]
) => {
    const mediaData = useMemo(
        () =>
            progress.map((progressItem) => {
                const isVideoFile = isVideo(progressItem.mime_type);
                const isImgFile = isImg(progressItem.mime_type);

                const url = isVideoFile
                    ? progressItem.video_url
                    : isImgFile
                    ? progressItem.original_url
                    : progressItem.original_url;

                return {
                    url,
                    mimeType: progressItem.mime_type,
                };
            }),
        [progress]
    );

    const uploadedTempMediaData = useMemo(
        () =>
            uploadedProgressMediaList.map((mediaItem) => ({
                id: mediaItem.id,
                mimeType: mediaItem.mime_type || '',
                previewUrl: mediaItem.original_url || mediaItem.preview_url,
                mediaUrl: mediaItem.video_url || mediaItem.original_url,
                date: mediaItem.date,
                description: mediaItem.description,
            })),
        [uploadedProgressMediaList]
    );

    const previewMediaMeta = useMemo(
        () => [
            ...uploadedProgressMediaList.map((mediaItem) => ({
                date: mediaItem.date || '',
                description: mediaItem.description || '',
            })),
            ...progress.map((progressItem) => ({
                date: progressItem.date || '',
                description: progressItem.description || '',
            })),
        ],
        [progress, uploadedProgressMediaList]
    );

    const previewMediaData = useMemo(
        () => [
            ...uploadedTempMediaData.map((mediaItem) => ({
                url: mediaItem.mediaUrl,
                mimeType: mediaItem.mimeType,
            })),
            ...mediaData,
        ],
        [mediaData, uploadedTempMediaData]
    );

    return {
        mediaData,
        uploadedTempMediaData,
        previewMediaMeta,
        previewMediaData,
    };
};
